var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"success"},[_c('img',{attrs:{"src":"https://cdn.gelonghui.com/webActive/img_content_success.png","alt":""}}),_vm._v(" "),_c('button',{on:{"click":_vm.beMember}},[_c('img',{attrs:{"src":"https://cdn.gelonghui.com/webActive/img_button_download.png","alt":""}}),_vm._v("立即下载\n  ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-748f252f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/pages/member-share/success.vue
// module id = q605
// module chunks = 1